import React, { useEffect } from "react";
import "./EducationPage.css";
import { setupLearnMoreToggle } from "../utils/toggleLearnMore";
import Hero from "../components/Hero";
import { Link } from "react-router-dom";

const EducationPage: React.FC = () => {
  useEffect(() => {
    setupLearnMoreToggle();
  }, []);
  return (
    <>
      <Hero page="education" titleTwo="Education At The Farm" />
      <div className="education-container">
        <div className="education-btns-container">
          <div className="info-card info-card-clickable">
            <a href="/education/internships">
              <h3>Internships</h3>
            </a>
          </div>
          <Link
            to="/education/tours-visits-and-lectures"
            className="info-card info-card-clickable"
          >
            <h3>Tours, visits & lectures</h3>
          </Link>
        </div>
      </div>
    </>
  );
};

export default EducationPage;
